import { handleAuthResponse } from "@/services/auth-service";

export default {
  /**
   * Login action: Handles authentication for Azure AD (Work) & Azure B2C (Personal)
   */
  async login({ commit }, accountType) {
    try {
      const token = await handleAuthResponse(accountType);
      if (token) {
        commit("setToken", token);
        commit("setUser", { accountType, token });
      } else {
        throw new Error("Authentication failed.");
      }
    } catch (error) {
      console.error("Login action failed:", error);
    }
  },
  /**
   * Logout action: Clears session & redirects to login
   */
  logout({ commit }) {
    try {
      commit("setToken", null);
      commit("setUser", null);
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout action failed:", error);
    }
  },
  /**
   * Fetch User Data: Retrieves user details after authentication
   */
  async fetchUserData({ commit, state }) {
    try {
      if (!state.token) {
        throw new Error("No authentication token found.");
      }
      // Simulate API call to fetch user data based on token
      const userData = {
        id: "1234",
        name: "John Doe",
        email: "user@example.com",
        role: state.accountType === "work" ? "Employee" : "Customer",
      };
      commit("setUser", userData);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  },
}; 